export const circleSizes = {
	small: 'w-4 h-4',
	medium: 'w-7 h-7',
	large: 'w-8 h-8',
};

export const rectangleShapes = [
	{
		key: 'rectangle1',
		sizes: {
			small: 'w-[69px] h-1',
			medium: 'w-[129px] h-[7px]',
			large: 'w-[160px] h-2',
		},
	},
	{
		key: 'rectangle2',
		sizes: {
			small: 'w-[32px] h-1',
			medium: 'w-[73px] h-[7px]',
			large: 'w-[90px] h-2',
		},
	},
];
